import React from 'react';
import Image from "next/legacy/image";
import Head from 'next/head';

import styles from '../styles/About.module.scss';
import TeamMember from '../components/TeamMember';
import { FaTwitter } from 'react-icons/fa';
import Link from 'next/link';

const Team = () => {
  return <>
    <Head>
      <title>The Team | Noundles</title>
    </Head>
      <div className="blue-gradient">
      <div className={styles.rainbow}>
        <div className="container">
          <div className="my-5">
            <h2 className="display-4 title mb-3">
              The Noundation
            </h2>
            <p className="lead">
              The Noundation team lives to serve the Noundles community!
              
              We run the Noundles business, paying all the project expenses (with 
              the lowest expense ratio of any major NFT project at 2.5%). We compensate moderators 
              and social media managers to help evolve the product and its positioning in the marketplace. 
              We also deliver benefits back to holders, such as buying items that holders could
              acquire using $Rainbows. Past benefits to Noundles holders have
              included getting 117 Noundles holders on the whitelist for
              Creepz Genesis, raffling off Doodle #3427 to diamond hands
              holders on Doodle Bowl Sunday and giving away 6 ETH+ in prizes 
              in the Chasing Rainbows event. 🌈
            </p>
          </div>
          <div className="row justify-content-center">

            <div className="col-12 col-lg-4">
              <TeamMember
                name="WKM"
                image="/team/wkm.png"
                twitter="wakemi18"
              >
                WKM is a senior software engineer at a large fintech company
                and leads development for a number of web3 projects. He enjoys
                drawing boxes on whiteboards and writing elegant lines of code
                en route to a gas efficient and exploit free future of
                Noundleville.
              </TeamMember>
            </div>
            <div className="col-12 col-lg-4">
              <TeamMember
                name="Elton Penguin"
                image="/team/elton.png"
                twitter="EltonPenguinNFT"
              >
                Elton Penguin is a senior product lead at a Silicon Valley
                tech unicorn. In his off-hours, he pours every waking thought
                (and many non-waking thoughts too!) into how to make Noundles
                a great experience for all Noundles holders.
              </TeamMember>
            </div>
            <div className="col-12 col-lg-4">
              <TeamMember
                name="241st.eth"
                image="/team/241st_eth.png"
                twitter="241st_eth"
              >
                241 is a senior marketing executive at the second largest advertising 
                agency worldwide, helping Fortune 500 companies survive in the attention 
                economy. He has been active on the Noundles server since November 2021, 
                and besides regular GMing, he likes to share ideas and strategies to make 
                Noundles competitive and create products that inspire.
              </TeamMember>
            </div>
            <div className="col-12 col-lg-4">
              <TeamMember
                name="PigeonHustle"
                image="/team/pigeonhustle.png"
                twitter="pharmacyshirt"
              >
                PigeonHustle is a 20+ year veteran of the Film &
                Television Industry and a member of the International
                Cinematographers Guild. His experience in NFT began over a
                year ago in TopShot and photography projects and has branched
                out from there. He has been with Noundles since its late night
                Genesis stealth drop.
              </TeamMember>
            </div>
            <div className="col-12 col-lg-4">
              <TeamMember
                name="Freddy123"
                image="/team/freddy123.png"
                twitter="Freezz09"
              >
                Freddy is a true Noundler. He is a steadfast advocate for the 
                Noundles community, brandishing his Dutch courage to shatter 
                the status quo. He is also one of the nicest people you will 
                ever meet (not to mention a master of the animated GIF!). In 
                his IRL life, he enjoys family time & gardening. He is a well 
                loved member of the community and we are proud to have him.
              </TeamMember>
            </div>
          </div>
        </div>
      </div>

      <div className={styles.team}>
        <div className={styles.hero}>
          <div className="container">
            <div className="row">
              <div className="col-12 col-md-5 d-flex flex-column justify-content-end">
                <Image
                  src="/beerhead.png"
                  alt="Beerhead"
                  width={894}
                  height={894}
                />
              </div>
              <div className="col-12 col-md-7 d-flex flex-column justify-content-center order-first order-md-last">
                <h1 className="display-4 title mb-3">
                  The Noundles Community
                </h1>
                <p className="lead">
                  Noundles is a tight-knit group! The Noundles community is
                  notable for its resiliency through turbulent times. We are steady, 
                  tested, and have our eyes fixated on the future.
                </p>
                <ul className="lead my-3">
                  <li>
                    <a
                      href="https://docs.google.com/document/d/1_EvFjoZHwf7RWebo9-uJoRjLwzLHnGjq_tb81XXo66g/edit"
                      target="_blank"
                      rel="noreferrer"
                    >
                      Project Constitution
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://docs.google.com/spreadsheets/d/1kBqSCJiE5wtKnYkkv3PYB9NzzME6z5yuHoyVg9UwXHw/edit#gid=0"
                      target="_blank"
                      rel="noreferrer"
                    >
                      Roadmap
                    </a>
                  </li>
                  <li>
                    <Link href="/shop" passHref>
                      Rainbow Shop
                    </Link>
                  </li>
                </ul>
                <p className="lead">
                  The Noundles community is super welcoming and always
                  available to answer questions! 🌈
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </>;
};

export default Team;
